import { Flex } from 'antd';
import styled from 'styled-components';

const StyledListItemMeta = styled.div`
  width: 100%;
  .ant-list-item-meta-title,
  .ant-typography {
    font-weight: 400;
    margin-bottom: 8px;
  }
`;

interface ListItemMetaNotificationProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  description?: React.ReactNode;
}

/**
 * Sezione finale stilizzata di una singola notifica
 *
 * Sostituito il List.Item.Meta di Ant con un div
 * perchè è wrappato con un elemento h4 non corretto per accessibilità
 */
export function ListItemMetaNotification(props: ListItemMetaNotificationProps) {
  const { title, description, ...otherProps } = props;
  return (
    <StyledListItemMeta {...otherProps}>
      <Flex vertical gap={6}>
        {title}
        {description}
      </Flex>
    </StyledListItemMeta>
  );
}
